import Plugin from "./Plugin";

export default {
  Plugin,
};
